module.exports = __webpack_public_path__ + "img/result-detail-communication-inleft02.53fdfa34.svg";